import { render, staticRenderFns } from "./QuestionImageUpload.vue?vue&type=template&id=5757c7ea&scoped=true&"
import script from "./QuestionImageUpload.vue?vue&type=script&lang=ts&"
export * from "./QuestionImageUpload.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionImageUpload.vue?vue&type=style&index=0&id=5757c7ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5757c7ea",
  null
  
)

export default component.exports